// extracted by css-extract-rspack-plugin
var _1 = "column-name-g4XY7_";
var _2 = "column-name-g4XY7_";
var _3 = "filter-rV3gdr";
var _4 = "projectType-jgl_U0";
var _5 = "table-Rhh2ul";
var _6 = "versions-UyIIFB";
var _7 = "versions-table-ROx0N_";
var _8 = "versions-table-ROx0N_";
export { _1 as "column-name", _2 as "columnName", _3 as "filter", _4 as "projectType", _5 as "table", _6 as "versions", _7 as "versions-table", _8 as "versionsTable" }
